type OperacaoSaldo = {
  status: string;
  valor_em_aberto?: number | null | undefined;
  proxima_parcela_data?: string | null | undefined;
  proxima_parcela_valor?: number | null | undefined;
};
export function resumoVincendas(operacoes: OperacaoSaldo[], hoje = new Date().toISOString().slice(0, 10)) {
  const abertas = operacoes.filter(o => !['quitada', 'cancelada'].includes(o.status));
  const total = abertas.some(o => o.valor_em_aberto == null)
    ? null : abertas.reduce((s, o) => s + (o.valor_em_aberto ?? 0), 0);
  const proxima = abertas.flatMap(o => o.proxima_parcela_data && o.proxima_parcela_data.slice(0,10) >= hoje
    ? [{data: o.proxima_parcela_data, valor: o.proxima_parcela_valor ?? 0}] : [])
    .sort((a,b) => a.data.localeCompare(b.data))[0];
  const subtotal = abertas.reduce((s, o) => s + (o.valor_em_aberto ?? 0), 0);
  const semCronograma = abertas.filter(o => o.valor_em_aberto == null).length;
  const comCronograma = abertas.length - semCronograma;
  return { total, subtotal, semCronograma, comCronograma, proxima };
}
